import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class UserTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "actionColumn", title: "Benutzer Einstellungen" },
        { name: "descriptionColumn", title: "Beschreibung" }
      ],
      rows: [
        { actionColumn: 'IP Adresse mitschneiden', descriptionColumn: 'Bei Aktivierung wird die IP-Adresse jedes Benutzers, der sich in den Videostream Ihrer Kameras einloggt, protokolliert. Überprüfen Sie dafür das Systemprotokoll Ihrer Kamera.' },
        { actionColumn: 'Administratorname', descriptionColumn: 'Dies ist der Benutzername und das zugehörige Kennwort für das Administrator-Login. Der Administrator hat Zugriff auf alle Funktionen der Kamera. Der Standard ist admin/instar. Der Benutzername wird während der ersten Schritte des Einrichtungsassistenten auf einen persönlichen Benutzernamen und ein Passwort festgelegt.' },
        { actionColumn: 'Benutzernamen', descriptionColumn: 'Dies ist der Benutzername und das zugehörige Kennwort für das Benutzer-Login. Der Benutzer kann neben dem Abrufen des Livestreams die Kamera auch Schwenken (nur PTZ Kameras). Das Konfigurationsmenü auf der rechten Seite wird für den Benutzer ausgeblendet. Standardmäßig deaktiviert.' },
        { actionColumn: 'Betrachternamen', descriptionColumn: 'Dies ist der Benutzername und das zugehörige Kennwort für das Besucher-Login. Der Besucher kann nur noch den Livestream der Kamera abgreifen. Das Konfigurationsmenü auf der rechten Seite wird für den Besucher ausgeblendet. Standardmäßig deaktiviert.' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

UserTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(UserTable)